import { render } from "./ImpersonateView.vue?vue&type=template&id=5b11cf0a&ts=true"
import script from "./ImpersonateView.vue?vue&type=script&lang=ts"
export * from "./ImpersonateView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__